import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFeather2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconFeather2"><Path d="M3.75 16.1029V20.25C3.75 16.9746 6.5 16.1029 9 16.1029C13.1643 16.1029 16.6578 12.1147 14.0757 8.89706C17.4661 8.89706 18.856 6.41115 20.25 3.75H16.1409C9.29758 3.75 3.75 9.2806 3.75 16.1029Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconFeather2;
